import React from 'react';
import { Button, Flex } from 'antd';

export const CategoryControls = ({
    setIsEdit,
    openEditor,
    setOpenEditor,
    selectedCategoryId,
}) => {
    return (
        <Flex justify={'space-between'} wrap={'wrap'} gap={20}>
            <Button
                disabled={false}
                type={'primary'}
                onClick={() => {
                    setIsEdit(false);
                    setOpenEditor(!openEditor);
                }}
            >
                {selectedCategoryId > 0
                    ? 'Добавить подкатегорию'
                    : 'Добавить категорию'}
            </Button>
        </Flex>
    );
};
